<template>
  <div class="mapboxgl-custom-legend">
    <!-- port size -->
    <v-card class="legend-container">
      <div class="pa-3">
        <h4 class="caption font-weight-bold">Cost ($US Billions)</h4>

        <v-layout class="legend-size mt-3">
          <v-flex xs6 align-self-center>
            <div class="legend-size__label">
              <div class="dotted-line" />
              <div class="label__inner"/>
              <div class="dotted-line2" />
            </div>
          </v-flex>

          <v-flex xs5 offset-xs1>
            <v-layout wrap fill-height>
              <v-flex xs12 class="caption">50</v-flex>
              <v-flex xs12 align-self-end mb-2 class="caption">0.006</v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-card>

    <!-- port category -->
    <v-card class="legend-container mt-3">
      <div class="pa-3">
        <h4 class="caption font-weight-bold mb-2">Category</h4>

        <v-layout row wrap align-start>
          <v-flex xs2>
            <div class="legend__label legend__circle" style="background-color: #99000d" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">China-owned</div>
          </v-flex>

          <v-flex xs2>
            <div class="legend__label legend__circle" style="background-color: #cb181d" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">Largely-owned by China</div>
          </v-flex>

          <v-flex xs2>
            <div class="legend__label legend__circle" style="background-color: #ef3b2c" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">Partially-owned by China</div>
          </v-flex>

          <v-flex xs2>
            <div class="legend__label legend__circle" style="background-color: #fb6a4a" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">Under Lease</div>
          </v-flex>

          <v-flex xs2>
            <div class="legend__label legend__circle" style="background-color: #fc9272" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">Awarded contract</div>
          </v-flex>

          <v-flex xs2>
            <div class="legend__label legend__circle" style="background-color: #fcbba1" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">Investment and construction</div>
          </v-flex>

          <v-flex xs2>
            <div class="legend__label legend__circle" style="background-color: #fee0d2" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">Partnership/Joint-venture</div>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'LegendPorts',
};
</script>

<style lang="stylus" scoped>
.legend-container {
  max-width: 190px;

  .legend-size {
    height: 7vh;

    .legend-size__label {
      position: relative;
      border: 1px solid #ff6505;
      border-radius: 50%;
      width: 100%;

      &:before {
        content: '';
        display: block;
        padding-top: 100%;
      }

      .dotted-line {
        position: absolute;
        top: 0;
        left: 50%;
        width: 50%;
        height: 1px;
        border-top: 1px dotted #f38063;
      }

      .dotted-line2 {
        position: absolute;
        bottom: 25%;
        left: 50%;
        width: 50%;
        height: 1px;
        border-top: 1px dotted #f38063;
      }

      .label__inner {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        border: 1px solid #ff6505;
        border-radius: 50%;
        width: 25%;
        height: 25%;
      }
    }
  }

  .legend__circle {
    width: 14px;
    height: 14px;
    border-radius: 50%;
  }
}
</style>
